import React, { useState } from "react";
import "../styles/InputIp.css";

function InputIp({
    value,
    setValue,
    label = "Dirección IP",
    title = "Formato: xxx.xxx.xxx.xxx",
    readOnly = false
}) {
    const [error, setError] = useState("");

    // Separar la IP en bloques
    const bloques = value ? value.split(".") : ["10", "33", "137", ""];

    const handleChange = (index, newValue) => {
        if (readOnly) return; // si es solo lectura, no permitir cambios

        // Validar que sea número entre 0 y 255
        if (!/^\d{0,3}$/.test(newValue)) return;
        if (newValue && (parseInt(newValue, 10) < 0 || parseInt(newValue, 10) > 255)) {
            setError("Cada bloque debe estar entre 0 y 255");
            return;
        }

        setError("");
        const nuevosBloques = [...bloques];
        nuevosBloques[index] = newValue;
        setValue(nuevosBloques.join("."));
    };

    return (
        <div className="form-group">
            <label>{label}</label>
            <div className="ip-input">
                {bloques.map((bloque, i) => (
                    <React.Fragment key={i}>
                        <input
                            type="text"
                            className={`ip-block ${error ? "input-error" : ""}`}
                            value={bloque}
                            onChange={(e) => handleChange(i, e.target.value)}
                            maxLength={3}
                            readOnly={readOnly}
                            title={title}
                        />
                        {i < 3 && <span className="dot">.</span>}
                    </React.Fragment>
                ))}
            </div>
            {error && <small className="error-text">{error}</small>}
        </div>
    );
}

export default InputIp;